var _title, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoJira = function SvgLogoJira(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Jira")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    d: "M40.581 22.993 25.009 7.502 23.5 6 11.774 17.661l-5.355 5.332a1.42 1.42 0 0 0 0 2.014l10.71 10.654L23.494 42l11.722-11.661.186-.181 5.178-5.151a1.421 1.421 0 0 0 0-2.014Zm-17.086 6.334L18.131 24l5.35-5.322L28.835 24l-5.34 5.327Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M23.495 18.649a8.856 8.856 0 0 1-2.695-6.318A8.852 8.852 0 0 1 23.461 6L11.656 17.813 18.094 24l5.401-5.351Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 22.524,
    x2: 15.082,
    y1: 13.259,
    y2: 20.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
};
export default SvgLogoJira;